export default "__VITE_ASSET__7abda820__"